import React from 'react';
import { Redirect } from 'react-router';
import PropTypes from 'prop-types';

export default class GoTo extends React.Component {

  static propTypes = {
    pathKey: PropTypes.string
  }

  render() {
    if (this.props.pathKey === 'plans') {
      return (
        <Redirect push to='/plans' />
      );
    } else if (this.props.pathKey && this.props.pathKey.startsWith('tack-board-notification-')) {
      const slug = this.props.pathKey.replace('tack-board-notification-', '');
      return (
        <Redirect push to={ `/tack_board/notification/${ slug }`} />
      )
    } else if (this.props.pathKey == 'tack_board') {
      return (
        <Redirect push to={ '/tack_board' } />
      )
    } else if (this.props.pathKey == 'points_board') {
      return (
        <Redirect push to={ '/account/points_board' } />
      )
    } else if (this.props.pathKey == 'people_board') {
      return (
        <Redirect push to={ '/people_board' } />
      )
    } else if (this.props.pathKey === 'pause_all') {
      return (
        <Redirect push to='/tacks/pause_all' />
      );
    } else if (this.props.pathKey === 'resume_all') {
      return (
        <Redirect push to='/tacks/resume_all' />
      );
    } else if (this.props.pathKey === 'recommend_people_to_follow') {
      return (
        <Redirect push to='/account/recommend_people_to_follow' />
      );
    } else if (this.props.pathKey && this.props.pathKey.startsWith('word-')) {
      const wordText = this.props.pathKey.replace('word-', '');
      return (
        <Redirect push to= { `/words/${wordText}` } />
      );
    } else if (this.props.pathKey && this.props.pathKey.startsWith('tackselection')) {
      const params = this.props.pathKey.split(':');
      const path = `/tacks/${params[1]}/selection/${params[2]}`;
      return (
        <Redirect push to= { path } />
      );
    } else if (this.props.pathKey && this.props.pathKey.startsWith('people-')) {
      const slug = this.props.pathKey.replace('people-', '');
      return (
        <Redirect push to= { `/people/${slug}` } />
      );
    } else {
      return (
        <Redirect push to='/' />
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/go_to.jsx